import { useCallback, useEffect, useState } from "react";

export type ColorMode = "light" | "dark";

const STORAGE_KEY = "colorMode";

const readStoredMode = (): ColorMode => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const applyColorMode = (mode: ColorMode) => {
  const root = document.documentElement;
  root.classList.toggle("dark", mode === "dark");
  root.classList.toggle("light", mode === "light");
  root.style.colorScheme = mode;
};

export const useColorMode = () => {
  const [colorMode, setColorMode] = useState<ColorMode>(readStoredMode);

  useEffect(() => {
    applyColorMode(colorMode);
    try {
      localStorage.setItem(STORAGE_KEY, colorMode);
    } catch {
      return;
    }
  }, [colorMode]);

  const toggleColorMode = useCallback(() => {
    setColorMode((mode) => (mode === "dark" ? "light" : "dark"));
  }, []);

  return { colorMode, setColorMode, toggleColorMode };
};
